export class FreelancerOnboardingAPIModel {
  CountryListAPI: any;
  StateListAPI: any;
  CityListAPI: any;
  SourceListAPI: any;
  InterestListAPI: any;
  LanguageListAPI: any;
  CategoryListAPI: any;
  UpdateFreelancerAPI: any;
  CheckDuplicateAPI: any;
  getFreelancerbyIdAPI: string;
  uploadtestfileapi: any;
  getFreelancertestfileAPI: string;
  getFreelancerupdatedtestfileAPI: string;



}
